const ADDRESS_STORE_CONSTANTS = {
  ADD_NEW_ADDRESS: 'Add New Address',
  EDIT_DELIVERY_ADDRESS: 'Edit Delivery Address',
  HIDDEN: 'hidden',
  OK: 'OK',
  KM: 'km',
  DEFAULT_DISPOSITION_TAKEWAY: 'Pickup',
  mapText: 'map',
  ZERO_RESULTS: 'ZERO_RESULTS',
  DELIVERY_SERVICE: 'delivery',
  CHANNEL: 'web',
  REMOVED_MSG: 'Store removed from favorite list',
  INDIA: 'India',
  NOT_SERVICEABLE: 'The Delivery location is not serviceable. Please choose a different address',
  INITIAL_STATE: {
    addressId: '',
    addressName: '',
    city: '',
    pinCode: '',
    name: '',
    state: '',
    country: '',
    isPrimary: false,
    location: {
      latitude: '',
      longitude: '',
    },
    addressLines: ['', ''],
  },
  MYDELIVERYADDRESSES: 'MyDeliveryAddresses',
  ADDRESS: 'address',
};

export default ADDRESS_STORE_CONSTANTS;
